import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {DropdownContext} from '../DropdownContext';

export type DropdownItemProps = {
  as?: 'button' | 'a';
  href?: string;
  onClick?(): void;
};

export const StyledDropdownItem = styled.div`
  width: 100%;
  display: block;
  text-align: left;
  box-sizing: border-box;
  white-space: nowrap;
  ${transition()};
  
  &:hover,
  &:focus-visible {
    background-color: ${({theme}) => `
      ${transparentize(.95, theme.colors.white)};
    `};
  }

  &:active {
    background-color: ${({theme}) => `
      ${transparentize(.9, theme.colors.white)};
    `};
  }
`;

/**
 * This is item of dropdown list.
 * @param {React.PropsWithChildren<DropdownItemProps>} props
 * @return {React.ReactElement<React.PropsWithChildren<DropdownItemProps>>}
 * @constructor
 */
export default function DropdownItem(
    props: React.PropsWithChildren<DropdownItemProps>,
): React.ReactElement<React.PropsWithChildren<DropdownItemProps>> {
  const {close} = React.useContext(DropdownContext);

  /**
   * The click event handler.
   */
  function handleClick(): void {
    props.onClick && props.onClick();
    close && close();
  }

  return (
    <StyledDropdownItem {...props} onClick={handleClick}>
      {props.children}
    </StyledDropdownItem>
  );
}
